import React, { useRef, useState } from 'react';

import { ArrowDropDown } from '@mui/icons-material';
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';

export interface BulkAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  actions: Array<BulkAction>;
  disabled?: boolean;
}

export default function BulkActionsButton({ actions = [], disabled = false }: Props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  if (!actions.length) {
    return null;
  }

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef} disabled={disabled}>
        <Button size="small" onClick={() => setOpen((prev) => !prev)}>
          Actions
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal sx={{ zIndex: 1 }}>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList>
                  {actions.map((action) => (
                    <MenuItem
                      key={action.label}
                      disabled={action.disabled}
                      onClick={() => {
                        action.onClick();
                        setOpen(false);
                      }}
                    >
                      {action.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
